export default __webpack_public_path__ + "static/media/factions_dark.ece6244f.svg";